export const documents = [
    // 📂 Documents d'état civil
    { nom: "Acte de naissance", destinataire: "" },
    { nom: "Livret de famille des parents", destinataire: "" },

    // 📂 Documents d'identité et de domicile
    { nom: "Justificatif d'identité", destinataire: "" },
    { nom: "Justificatif de domicile", destinataire: "" },
];